import React, { Component } from 'react'
import { Typography } from '@material-ui/core'

export default class CreateGameEconomicsServicesComponent extends Component {
    render() {
        return (
            <div>
                <Typography variant="h4">Služby</Typography>
            </div>
        )
    }
}
